import ReactHtmlParser from "react-html-parser";

const ADR_Data_Transfer_Failure = (params) => ReactHtmlParser(
`
<div>
    <p><strong>SOP</strong></p>
    <ol>
        <li>Unplug the Ethernet (CAT6) cable and replug it again. Validate if data transfer resumes on SCC.</li>
        <li>If data transfer does not resume, unplug the Ethernet cable, power cycle (restart) the robot and plug back the cable. Validate if data transfer resumes on SCC.</li>
        <li>Create a ticket through River.</li>
    </ol>
</div>
`
);

export default ADR_Data_Transfer_Failure;



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Data_Transfer_Failure.jsx